import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { partnerService } from '../services/partnerService';

const PartnerContext = createContext({});

export const usePartner = () => {
  const context = useContext(PartnerContext);
  if (!context) throw new Error('usePartner must be used within PartnerProvider');
  return context;
};

export const PartnerProvider = ({ children }) => {
  const [partners, setPartners] = useState([]);
  const [selectedPartnerId, setSelectedPartnerId] = useState(null);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadPartners = useCallback(async () => {
    setLoading(true);
    try {
      const data = await partnerService?.getAll();
      setPartners(data || []);
      // Auto-select first partner if none selected
      if (!selectedPartnerId && data?.length > 0) {
        setSelectedPartnerId(data?.[0]?.id);
        setSelectedPartner(data?.[0]);
      }
    } catch (err) {
      console.error('PartnerContext: failed to load partners', err);
    } finally {
      setLoading(false);
    }
  }, [selectedPartnerId]);

  useEffect(() => {
    loadPartners();
  }, []);

  const switchPartner = useCallback((partnerId) => {
    const partner = partners?.find(p => p?.id === partnerId);
    setSelectedPartnerId(partnerId);
    setSelectedPartner(partner || null);
  }, [partners]);

  const value = {
    partners,
    selectedPartnerId,
    selectedPartner,
    loading,
    switchPartner,
    refreshPartners: loadPartners,
  };

  return (
    <PartnerContext.Provider value={value}>
      {children}
    </PartnerContext.Provider>
  );
};

export default PartnerContext;
